import { styled } from '@mui/material';

import { ResponsiveContainer } from '~/components/ResponsiveContainer/ResponsiveContainer.tsx';

export const ResponsiveContainerStyled = styled(ResponsiveContainer)({
  flex: '1 1 0',
});
